import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/database";
import "firebase/auth";
import "firebase/functions";
import "firebase/storage";

// FIREBASE PRODUCTION:
const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
};

firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const FieldValue = firebase.firestore.FieldValue;
const rtdb = firebase.database();
const auth = firebase.auth();
const f = firebase.functions();
const storage = firebase.storage().ref();

// date issue fix according to firebase
const settings = {
  //timestampsInSnapshots: true
};

db.settings(settings);

// firebase collections
const customers = db.collection("stripe_customers");
const profiles = db.collection("user_profiles");
const orders = db.collection("user_orders");
const ordersteps = db.collection("order_steps");
const invoices = db.collection("stripe_invoices");
const subscriptions = db.collection("user_subscriptions");
const logs = db.collection("order_logs");
const paymentlinks = db.collection("payment_links");
const partners = db.collection("partner_profiles");
const businessprofiles = db.collection("business_profiles");
const businessplans = db.collection("business_plans");
const charges = db.collection("stripe_charges");

export default {
  db,
  FieldValue,
  rtdb,
  auth,
  f,
  storage,
  customers,
  profiles,
  subscriptions,
  orders,
  charges,
  ordersteps,
  invoices,
  logs,
  paymentlinks,
  partners,
  businessprofiles,
  businessplans
};
